import { jsx as _jsx } from "react/jsx-runtime";
import { faInfo } from '@fortawesome/free-solid-svg-icons/faInfo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export var ProductToggleIcon = function () {
    return _jsx(FontAwesomeIcon, { icon: faInfo, size: "lg" });
};
